import Model from '@/models/Model.js';
import ReadReceipt from '@/models/ReadReceipt.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class Message extends Model {
    static entity = 'messages';

    static modelName = 'Message';

    static includes = ['tags', 'media', 'messageCategories', 'courses'];

    static queryBuilder() {
        return new QueryBuilder(this.entity).include(this.includes);
    }

    static fields() {
        return {
            id: this.attr(null),
            sender_id: this.string(''),
            title: this.string(''),
            body: this.string(''),
            subject: this.string(''),
            seen_at: this.attr(null),
            dismissed_at: this.string(''),
            created_by: this.number(0),
            updated_by: this.number(0),
            deleted_by: this.number(0),
            media: this.attr(null),
            tags: this.attr(null),
            message_categories: this.attr(null),
            read: this.attr(null),
            alertType: this.attr(null),

            ...super.fields(),

            sender: this.belongsTo('users', 'sender_id'),
            read_receipts: this.morphMany('read_receipts', 'readable_id', 'readable_type_entity'),
        };
    }

    static async fetch(endpoint) {
        const { response } = await this.api().get(endpoint, {
            persistBy: 'create',
        });

        return response.data;
    }

    static fetchOne(slug) {
        const queryBuilder = new QueryBuilder(`${this.entity}/${slug}`);

        const url = queryBuilder.include(this.includes).toUrl();

        return this.api().get(url);
    }

    markAsRead() {
        return ReadReceipt.api().put('/api/mark-as-read', {
            readable_id: this.id,
            readable_type: 'App\\Models\\Message',
        });
    }

    markUnread() {
        return ReadReceipt.api().put('/api/mark-as-unread', {
            readable_id: this.id,
            readable_type: 'App\\Models\\Message',
        });
    }

    static archive(messages) {
        return this.api().post('api/archive-messages', messages);
    }

    static markAsSeen(message) {
        const endpoint = 'api/messages/mark-as-seen';
        return this.api().put(endpoint, message);
    }

    static unarchive(messages) {
        return this.api().delete('api/archive-messages', { data: messages });
    }

    get formatted_created_at() {
        return this.timestamp('created_at').format('MM/DD/YYYY - h:mm a');
    }

    get backend_class() {
        return 'App\\Models\\Message';
    }
}
